import React from "react";
import { AbsoluteFill, useCurrentFrame, interpolate } from "remotion";

export const BreathingCircle: React.FC<{ opacity?: number }> = ({ opacity = 1 }) => {
  const frame = useCurrentFrame();
  // 4-second breath cycle at 30fps = 120 frames
  const breathPhase = (frame % 120) / 120;
  const breathScale = 0.6 + Math.sin(breathPhase * Math.PI * 2) * 0.4;
  const glowOpacity = 0.15 + Math.sin(breathPhase * Math.PI * 2) * 0.1;

  return (
    <AbsoluteFill style={{ opacity, display: "flex", alignItems: "center", justifyContent: "center" }}>
      {/* Outer glow rings */}
      {[1.6, 1.3, 1.0].map((scale, i) => (
        <div key={i} style={{
          position: "absolute",
          width: 300 * breathScale * scale,
          height: 300 * breathScale * scale,
          borderRadius: "50%",
          border: `1px solid rgba(243, 112, 33, ${0.08 * (3 - i)})`,
          background: `radial-gradient(circle, rgba(212, 168, 67, ${glowOpacity * (1 - i * 0.3)}) 0%, transparent 70%)`,
          transition: "all 0.1s",
        }} />
      ))}
      {/* Core circle */}
      <div style={{
        position: "absolute",
        width: 180 * breathScale,
        height: 180 * breathScale,
        borderRadius: "50%",
        background: `radial-gradient(circle, rgba(243, 112, 33, ${0.25 + glowOpacity}) 0%, rgba(95, 37, 159, 0.15) 60%, transparent 100%)`,
        boxShadow: `0 0 ${60 * breathScale}px rgba(243, 112, 33, ${glowOpacity})`,
      }} />
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
